import styled from 'styled-components';
import { breakpoints } from "../../../../utils/styledBreakpoints";

export const IEBaseContainerElement = styled.div`
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 0.71429rem;
    background: var(--bgbg-white, #FFF);
    box-shadow: 0px 0px 6px 0px rgba(185, 186, 202, 0.33);
    height: fit-content;
    min-height: 100vh;
    width: 100%;
    padding: 1.7rem;
    font-family: 'Poppins';
    padding-bottom: 9rem;

    ${breakpoints("width", "", [{ 991: `auto` }])};
    ${breakpoints("margin", "rem", [{ 991: 0 }])};
    ${breakpoints("padding-bottom", "px", [{ 991: 120 }])};
    ${breakpoints("flex-grow", "", [{ 991: `1` }])};
    ${breakpoints("margin-top", "px", [{ 991: 20 }])};
    ${breakpoints("border", "px", [{ 991: 20 }])};
    ${breakpoints("border-top-left-radius", "px", [{ 991: 20 }])};
    ${breakpoints("border-top-right-radius", "px", [{ 991: 20 }])};

    .flex-container {
        display: flex;
        flex-direction: column;
        gap: 1.7rem;

        ${breakpoints("gap", "rem", [{ 991: 0 }])};
    }

    .ie-contaier-header {
        display: flex;
        flex-direction: row;
        height: fit-content;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        flex-wrap: wrap;
        ${breakpoints("flex-direction", "", [{ 991: `column` }])};
    }

    .ie-contaier-header .ie-contaier-header-text h1 {
        font-size: 2rem;
        font-weight: 700;

        ${breakpoints("margin-bottom", "rem", [{ 991: `2` }])};
    }

    .ie-contaier-header .ie-header-date-container {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        line-height: initial;
        font-size: 0.92857rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.25rem;
        letter-spacing: 0.03714rem;
        text-transform: uppercase;
        flex-basis: 100%;
        margin-top: 1rem;
        order: 4;
        gap: 0.5rem;
        ${breakpoints("order", "", [{ 991: `2` }])};
        ${breakpoints("width", "%", [{ 991: `100` }])};
    }
    .ie-contaier-header .ie-header-date-container .react-datepicker-wrapper {
        width: 100%;
    }

    .ie-contaier-header .ie-header-date-container .react-datepicker-wrapper input {
        padding: 15px 16px 14px;
        font-size: 0.92857rem;
        font-style: normal;
        line-height: 1.25rem;
        letter-spacing: 0.03714rem;
        text-transform: uppercase;
        font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
        line-height: 1.2857;
        border-radius: 4px;
        border: 1px solid #949494;
        outline: none;
        width: calc((100% - 3.5rem) / 3);
    }

    .react-datepicker__triangle {
        display: none;
    }

    .ie-contaier-header .ie-header-date-container .react-datepicker-wrapper input.react-datepicker-ignore-onclickoutside {
        outline: 1.5px solid var(--primary-active);
    }

     .react-datepicker {
        box-shadow: 0 2px 7px rgba(0,0,0,.2);
        border: 0;
     }

    .react-datepicker,
    .react-datepicker__month-text--today {
        font-family: Roboto,RobotoFallback,"Noto Kufi Arabic",Helvetica,Arial,sans-serif;
        font-weight: 400 !important;
    }

    .react-datepicker__day--keyboard-selected {
        background-color: none;
    }

    .react-datepicker__day--selected,
    .react-datepicker__month-text--keyboard-selected {
        color: #000;
        background-color: rgba(0,0,0,.12);
        font-weight: bold !important;
    }

    .react-datepicker__month .react-datepicker__month-text {
        padding: 14px 16px 13px;
    }

    .ie-contaier-header .summary-items-container {
        display: none;
        flex-direction: row;
        gap: 2.8rem;
        order: 3;
        ${breakpoints("display", "", [{ 991: `flex` }])};
        ${breakpoints("margin-top", "rem", [{ 991: `1.7` }])};
        ${breakpoints("gap", "rem", [{ 991: `1` }])};

        
    }

    .dx-tabs {
        height: fit-content;
        border-radius: 7.14286rem;
        padding: 0.25rem;
        width: 40%;
        background: var(--bg-blue-01, #EDEFFE);
        order: 1;
        ${breakpoints("width", "%", [{ 991: `100` }])};
    }

    .dx-tabs-nav-buttons .dx-tabs-scrollable {
        margin: 0;
        border-radius:7.14286rem;
        overflow: hidden
    }

    .dx-tabs-scrollable .dx-scrollable-container {
        border-radius:7.14286rem;
        overflow: hidden;
    }

    .dx-tabs-nav-button {
        display: flex;
        align-items: center;
        position: absolute;
        height: 100% !important;
        padding:0;
    }

    .dx-tabs-nav-button.dx-tabs-nav-button-left{
        left: -20px
    }

    .dx-tabs-nav-button.dx-tabs-nav-button-right{
        right: -20px
    }
    


    .dx-tab {
        border-radius: 3.57143rem;
        background: var(--bg-blue-01, #EDEFFE);
    }

    .dx-tab.dx-tab-selected {
        background: var(--button-primary-color, #4C60F2);
        color: var(--button-primary-text-color, #FFFFFF);
    }

    .dx-tab.dx-tab-selected::before {
        display: none;
    }

    .dx-tab-content, .dx-tab-text {
        font-size: 1.15rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.25rem;
        letter-spacing: 0.03714rem;
        text-transform: none;
        color: #000000DE;
    }

    .dx-tab-selected .dx-tab-content .dx-tab-text {
        color: var(--button-primary-text-color, #FFFFFF);
    }

    .szh-accordion {
        width: 100%;
    }

    .household-data-container .szh-accordion {
        background: #edeffe;
        border-radius: 0.71429rem;
    }

    .household-data-container .szh-accordion .szh-accordion__item-heading button {
        background: #edeffe;
        border-radius: 0.71429rem;
    }

    .szh-accordion__item-heading button[aria-expanded="true"] {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .szh-accordion__item-heading {
        font-size: 0 !important;
        position: relative;
    }

    .szh-accordion__item-heading:hover {
        cursor: pointer;
        background-color: #F7F8FC;
        border-radius: 0.71429rem;
    }

    .szh-accordion__item-heading button {
        outline: none;
        border: none;
        background-color: unset;
        width: 100%;
        padding: 1.25rem;
        display: flex;
        align-items: center;   
    }

    .szh-accordion__item-heading button[aria-expanded="false"]:before {
        content: "";
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 6L8 11L3 6' stroke='%23A5A6BF' stroke-width='1.54019' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position-y: center;
        background-size: 1.25rem;
        width: 1.25rem;
        height: 1.25rem;
        display: flex;
        transition: 0.1s ease;
        position: absolute;
        right: 1rem;
    }

     .szh-accordion__item-heading button[aria-expanded="true"]:before {
        content: "";
        padding-left: 3rem;
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 6L8 11L3 6' stroke='%23A5A6BF' stroke-width='1.54019' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: 1.25rem;
        width: 1.25rem;
        height: 1.25rem;
        display: flex;
        transform: rotate(180deg);
        transition: 0.1s ease;
        position: absolute;
        right: 1rem;
    }

    .szh-accordion__item-content {
        padding-top: 0.7rem;
        transition: height 0.25s cubic-bezier(0, 0, 0, 1);
    }

    .szh-accordion__item:not(:last-child) {
        border-bottom: 1px solid rgb(204, 205, 221);
    }

    .szh-accordion__item.szh-accordion__item--expanded {
        padding-bottom: 1.7rem;
    }

    .szh-accordion__item-panel {
        display: flex;
        flex-wrap: wrap;
        gap: 1.7rem;
    }
`;

export const IECategoryContainerElement = styled.div`
    display: ${props => props.$hidedesktop ? 'none' : 'flex'};
    gap: 1.7rem;
    flex-wrap: wrap;

    ${breakpoints("margin-top", "rem", [{ 991: `1.7` }])};
    ${breakpoints("display", "", [{ 991: 'flex' }])};
`;

export const ErrorIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    &:after {
        width: 22px;
        height: 22px;
        font-size: 14px;
        font-weight: 500;
        background-color: #f44336;
        color: #fff;
        content: "!";
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1rem;
    }
`;

export const GroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: #F7F8FC;
    border-radius: 12px;
    padding: 16px 20px 20px 20px;
    gap: 24px;
    width: 100%;
    ${breakpoints("padding", "", [{ 991: `0` }])};

    
    .group-header {
        display: flex;
        justify-content: space-between;
        text-align: left;
        align-items: center;

        ${breakpoints("margin-right", "rem", [{ 991: `1.5` }])};
        ${breakpoints("flex-basis", "%", [{ 991: `100` }])};
    }

    .group-header.household {
        justify-content: flex-start;
    }

    .group-header .household-icon {
        height: 100%;
        width: 2rem;
        border-radius: 100%;
        min-height: 2rem;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        z-index: 1;
        background-image: var(--household-icon);
        margin-right: 1rem;
    }

    .group-content {
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        width: 100%;

        ${breakpoints("flex-wrap", "", [{ 991: `nowrap` }])};
        ${breakpoints("flex-direction", "", [{ 991: `column` }])};
        ${breakpoints("padding", "", [{ 991: `16px 20px 20px 20px` }])};
        
    }

    .group-content.household-details {
        align-items: flex-start;
        gap: 0.7rem;
    }

    .group-content.household-details .household-data {
        display: flex;
        width: 100%;
        font-size: 1.15rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: flex-start;
    }


    &.earnings,
    &.pensions,
    &.utilitiesCosts,
    &.water,
    &.careAndHealthCosts,
    &.schoolCosts,
    &.pensionsAndInsurances,
    &.professionalCosts {
         flex-basis: calc(50% - (4px * 3));

         ${breakpoints("flex-basis", "%", [{ 991: `100` }])};
    }

    &.earnings,
    &.schoolCosts  {
        .group-content > div:nth-child(-n+2) {
            flex-basis: calc(50% - (4px * 3));
        }

        .group-content > div:nth-child(n+3) {
           flex-basis: 100%;
        }
    }

    &.pensions,
    &.utilitiesCosts,
    &.careAndHealthCosts,
    &.pensionsAndInsurances,
    &.professionalCosts {
        .group-content > div {
            flex-basis: calc(50% - (4px * 3));
        }
    }

    &.benefitsAndTaxCredits,
    &.homeAndContents,
    &.foodAndHouseKeeping {
        .group-content > div:nth-child(-n+5) {
            flex-basis: calc(20% - (4px * 5));
        }

        .group-content > div:nth-child(n+6) {
           flex-basis: calc(25% - (4px * 5));
        }
    }

     &.communicationsAndLeisure {
        .group-content > div:nth-child(-n+4) {
            flex-basis: calc(25% - (4px * 5));
        }

        .group-content > div:nth-child(n+5) {
            flex-basis: calc(33% - (4px * 4));
        }
    }

    &.transportAndTravel,
    &.personalCosts {
        .group-content > div {
            flex-basis: calc(25% - (4px * 5));
        }
    }

    &.otherIncome,
    &.otherEssentialCosts {
        .group-content > div {
            flex-basis: calc(20% - (4px * 5));
        }
    }

    .group-header .group-name, 
    .group-header .group-total {
        font-size: 1.25rem;
        font-weight: 600;
        color: #000000;
    }

    .group-header .group-total {
        display: flex;
        background: #fff;
        padding: 2px 8px 2px 8px;
        border-radius: 100px;
        align-items: center;
    }

    .group-header .group-total.exceeded-guidelines {
        background: #f5e4e7;
    }

    .group-header .group-total.exceeded-guidelines:hover {
        background: #f1c5c8;
    }

    .group-header .group-total.exceeded-guidelines .alert-icon {
        height: 100%;
        width: 1.5rem;
        border-radius: 100%;
        min-height: 2rem;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: var(--alert-icon);
        margin-right: 6px; 
    }
`;